import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import adminApi from '../../APIs/admin';
import {
  Button,
  PageHeader,
  Pagination,
  Table,
  Typography,
} from '../../designComponents';
import { ADD_USER_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import { PaginationType } from '../../types';
import { requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { UsersStyled } from './style';
import { getTableData } from './userTableData';

const Users = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const departmentUsers = useSelector(
    (state: RootState) => state.departmentUsersData.data,
  );
  const pagination = useSelector(
    (state: RootState) => state.departmentUsersData.pagination,
  );

  const getDepartmentUsers = async (myParams: MyParamsType) => {
    try {
      await requestAPI(
        adminApi.getDepartmentUsers({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        }),
      );
    } catch (error: any) {
      console.error(error);
      toast.error(error);
    }
  };
  const debouncedFunction = useCallback(
    debounce((myParams) => getDepartmentUsers(myParams), 500),
    [],
  );
  useEffect(() => {
    getDepartmentUsers(pagination);
  }, []);
  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };
  const handlePagination = (updatedParams: PaginationType) => {
    getDepartmentUsers(updatedParams);
    dispatch(
      Store.Actions.update('departmentUsersData.pagination', updatedParams),
    );
  };
  return (
    <UsersStyled>
      <PageHeader
        pageTitle={
          <Typography strong variant="title">
            User List
          </Typography>
        }
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
        otherActions={
          <Button
            variant="secondary"
            size="sm"
            onClick={() => navigate(ADD_USER_ROUTE)}
          >
            <FaPlus /> Add User
          </Button>
        }
      />
      <div className="table-container">
        <Table tableData={getTableData(navigate, departmentUsers)} />
      </div>
      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination?.totalData || 0}
      />
    </UsersStyled>
  );
};

export default Users;
